import CenterCostSection from './CenterCostSection';

class CenterCostType {
  static CHANNEL = 'channel';
  static DELEGATION = 'delegation';
  static AREA = 'area';
  static PROJECT = 'project';

  constructor(private code: string) {}

  public static channel(): CenterCostType {
    return new CenterCostType(CenterCostType.CHANNEL);
  }

  public static delegation(): CenterCostType {
    return new CenterCostType(CenterCostType.DELEGATION);
  }

  public static area(): CenterCostType {
    return new CenterCostType(CenterCostType.AREA);
  }

  public static project(): CenterCostType {
    return new CenterCostType(CenterCostType.PROJECT);
  }

  public isChannel(): boolean {
    return this.code === CenterCostType.CHANNEL;
  }

  public isDelegation(): boolean {
    return this.code === CenterCostType.DELEGATION;
  }

  public isArea(): boolean {
    return this.code === CenterCostType.AREA;
  }

  public isProject(): boolean {
    return this.code === CenterCostType.PROJECT;
  }

  public relatedType(): CenterCostType | null {
    switch (this.code) {
      case CenterCostType.DELEGATION:
        return CenterCostType.channel();
      case CenterCostType.AREA:
        return CenterCostType.delegation();
      case CenterCostType.PROJECT:
        return CenterCostType.area();
      default:
        return null;
    }
  }

  public centerCostSection(): CenterCostSection {
    switch (this.code) {
      case CenterCostType.CHANNEL:
        return CenterCostSection.canal();
      case CenterCostType.DELEGATION:
        return CenterCostSection.delegacion();
      case CenterCostType.AREA:
        return CenterCostSection.departamento();
      case CenterCostType.PROJECT:
        return CenterCostSection.proyecto();
      default:
        throw new Error(`Unknown CenterCostType code: ${this.code}`);
    }
  }

  public value(): string {
    return this.code;
  }
}

export default CenterCostType;
